import { ReserveButton } from "@/components/layout/ReserveButton";
import { LineButton } from "@/components/layout/LineButton";

/**
 * 料金表の各カテゴリ末尾に共通配置するCTA。
 * 外部予約ページ（ReserveButton）とLINE導線を利用する。
 */
export default function PriceCategoryCta() {
  return (
    <div className="border-t border-foreground-950/12 bg-background-100/60 px-6 py-8 md:px-10 md:py-9">
      <p className="text-[13px] leading-[2] text-foreground-700">
        料金やプランについてのご相談も承っています。施術内容が決まっていない方も、
        <span className="text-foreground-950">LINEまたはカウンセリング</span>
        からお気軽にご相談ください。
      </p>

      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
        <ReserveButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-7 py-3.5 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-700">
          <i className="ri-calendar-check-line text-base" aria-hidden />
          無料カウンセリングを予約
        </ReserveButton>
        <LineButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 px-7 py-3.5 text-[14px] text-foreground-900 transition-colors hover:bg-background-100">
          <i className="ri-line-fill text-base" aria-hidden />
          LINEで相談
        </LineButton>
      </div>
    </div>
  );
}